import type { FC } from 'react';
import type { DocumentWithdrawRequest } from 'src/apis/document-exchange/use-document-withdraw';
import { Button } from 'src/components/buttons-and-actions/button';
import { Modal } from 'src/components/overlay/modal';
import { useCountdown } from 'src/hooks/use-countdown';

type Props = {
  onDismiss?: () => void;
  documentWithdraw: DocumentWithdrawRequest;
};

export const WithdrawDocumentModal: FC<Props> = ({
  documentWithdraw,
  onDismiss,
}) => {
  const seconds = useCountdown();

  return (
    <Modal
      data-testid="withdraw-operator-document-modal"
      title="Withdraw Document"
      onDismiss={onDismiss}
      confirmButton={
        <Button
          mode="primary"
          data-testid="withdraw-submit-btn-modal"
          disabled={documentWithdraw.pending || seconds !== 0}
          onClick={documentWithdraw.execute}
        >
          {seconds
            ? `Wait ${seconds}s to proceed...`
            : documentWithdraw.pending
              ? 'Withdrawing...'
              : 'Submit'}
        </Button>
      }
      closeButton={
        <Button mode="secondary" data-testid="close-modal" onClick={onDismiss}>
          Close
        </Button>
      }
    >
      <p>
        Do you want to withdraw this document? This document will be hidden for
        the shipper.
      </p>
    </Modal>
  );
};
